module.exports = __webpack_public_path__ + "static/media/userIcon.07a71655.svg";